<div *ngIf="data.isSuccess === true" id="failureSnack" class="snackBar alert-success">{{ data.msg }}</div>

<div *ngIf="data.isSuccess === false" id="successSnack" class="snackBar alert-danger">{{ data.msg }}</div>

<div *ngIf="data.isSuccess === 'created'" class="snackBar alert-danger" name="Success Message">{{ data.msg }}</div>

<div *ngIf="data.isSuccess === 'error'" class="snackBar alert-danger" name="Failure Message">{{ data.msg }}</div>
